// MuiSwitch.ts
import { switchClasses, Theme } from '@mui/material';

const getMuiSwitch = () => ({
  styleOverrides: {
    root: ({ theme }: { theme: Theme }) => ({
      width: 38,
      height: 20,
      padding: 0,

      // Base-Button
      [`.${switchClasses.switchBase}`]: {
        padding: 3,
        transitionDuration: '200ms',

        // Thumb (unchecked)
        [`.${switchClasses.thumb}`]: {
          width: 14,
          height: 14,
          boxShadow: '0 1px 3px rgba(0,0,0,0.3)',
        },

        // Checked
        '&.Mui-checked': {
          transform: 'translateX(18px)',
          color: theme.palette.common.white,

          [`& + .${switchClasses.track}`]: {
            backgroundColor: '#1f1f1f',
            opacity: 1,
          },

          [`.${switchClasses.thumb}`]: {
            boxShadow: theme.boxShadow.down1,
          },
        },

        // Focus
        '&.Mui-focusVisible .MuiSwitch-thumb': {
          border: `1px solid ${theme.palette.primary.main}`,
        },

        // Disabled
        '&.Mui-disabled + .MuiSwitch-track': {
          opacity: 0.4,
        },
      },

      // Track
      [`.${switchClasses.track}`]: {
        borderRadius: 12,
        backgroundColor: '#e0e0e0',
        opacity: 1,
        transition: theme.transitions.create('background-color', { duration: 200 }),
      },
    }),
  },
});

export default getMuiSwitch;
